import { color, Common } from '@stockbit/ui';
import { Button, Modal, ModalText } from '../Modals/ModalDelete/styled';

const { Text } = Common;

interface ModalDeleteNoteProps {
  onCancel: () => void;
  visible: boolean;
  handleDelete: () => void;
}

function ModalDeleteNote({
  onCancel,
  visible,
  handleDelete,
}: ModalDeleteNoteProps) {
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      title={
        <Text size="20px" height="54px" family="bold">
          Delete Note
        </Text>
      }
      closeIcon={null}
      footer={[
        <Button
          key="cancel"
          block
          height="40px"
          onClick={onCancel}
        >
          <Text align="center" family="bold" color={color.sunsetOrange}>
            Cancel
          </Text>
        </Button>,
        <Button
          key="confirm"
          block
          type="secondary"
          height="40px"
          onClick={handleDelete}
        >
          <Text align="center" family="bold" color={color.light}>
            Delete
          </Text>
        </Button>,
      ]}
      transitionName=""
      maskTransitionName=""
    >
      <ModalText size="14px" height="19px" align="center">
        Are you sure want to delete this note?
      </ModalText>
    </Modal>
  );
}

export default ModalDeleteNote;
